import React from 'react';
import PropTypes from 'prop-types';
import { FakeText } from '@totalsoft/rocket-ui';
import RefineAuthorizationListResponsiveTable from './RefineAuthorizationListResponsiveTable';

const RefineAuthorizationListTable = ({ userGroups, dispatch, loading, changedRefinePermissions, allowedStates, authorization }) => {
  return loading ? (
    <FakeText lines={10} />
  ) : (
    <RefineAuthorizationListResponsiveTable
      userGroups={userGroups}
      allowedStates={allowedStates}
      dispatch={dispatch}
      changedRefinePermissions={changedRefinePermissions}
      authorization={authorization}
    />
  );
};

RefineAuthorizationListTable.propTypes = {
  userGroups: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  changedRefinePermissions: PropTypes.object,
  allowedStates: PropTypes.array,
  authorization: PropTypes.object
};

export default RefineAuthorizationListTable;
